export default {
    en: {
        id: 'exercise2',
        subtitle: 'SUGGESTED STRUCTURE <br> THE SALES FORCE EFFECTIVENESS PARADOX',
        blocks: [
            {
                task: 'Low sales force productivity is causing problems',
                title: "S = ",
                answer: ' ',
                note: 'Sit, DE, R1, R2',
                disableEdit: true
            },
            {
                task: 'Interviewed 25 CEOs to pinpoint reasons, identify what can be done about it',
                title: "C = ",
                answer: ' ',
                note: 'Sol',
                disableEdit: true
            },
            {
                task: '(What conclude?)',
                title: "Q = ",
                answer: ' ',
                disableEdit: true
            }
        ],
        image: '5b1-2.png',
        withoutAnswers: true,
        hideTaskTitle: true,
        submitButton: 'switch'
    },
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/5/5b/practiceDefiningProblem/i18n/exercise2.js